import { type BatchData } from 'prove-common'
import { RJSFSchema } from 'prove-common/rjsf'

export interface AnalysisTypeFormData {
  productId: number
  matrixId: number
  substanceIds: number[]
  payloadSchemaId: number
}

export const getAnalysisTypeSchema = (
  batchData: BatchData,
  labId: number | undefined
): RJSFSchema => {
  const matrices = batchData?.matrices
  const products = batchData?.products
  const substances = batchData?.substances
  const payloadSchemas = batchData?.payloadSchemas.filter(
    (schema) => schema.labId === labId
  )
  return {
    type: 'object',
    properties: {
      productId: {
        type: 'number',
        title: 'Produkt',
        description: 'Velg produktet prøven skal tas av',
        oneOf: products?.map((product) => {
          return {
            const: product.id,
            title: product.name
          }
        })
      },
      matrixId: {
        type: 'number',
        title: 'Prøve av',
        description: 'Velg matrisen prøven skal tas av',
        oneOf: matrices?.map((matrix) => {
          return {
            const: matrix.id,
            title: matrix.name
          }
        })
      },
      substanceIds: {
        type: 'array',
        title: 'Analyser for',
        description: 'Velg hva det skal analyseres for',
        default: [],
        minItems: 1,
        uniqueItems: true,
        items: {
          type: 'number',
          default: '',
          oneOf: substances?.map((substance) => {
            return {
              const: substance.id,
              title: substance.name
            }
          })
        }
      },
      payloadSchemaId: {
        type: 'number',
        title: 'Skjema',
        description: 'Velg skjema for prøvene',
        oneOf: payloadSchemas?.map((payloadSchema) => {
          return {
            const: payloadSchema.id,
            title: payloadSchema.name ?? payloadSchema.id.toString()
          }
        })
      }
    },
    required: ['productId', 'matrixId', 'substanceIds', 'payloadSchemaId']
  }
}
